import { render, staticRenderFns } from "./FanLogDetail.vue?vue&type=template&id=3fe54f1a&scoped=true&"
import script from "./FanLogDetail.vue?vue&type=script&lang=js&"
export * from "./FanLogDetail.vue?vue&type=script&lang=js&"
import style0 from "./FanLogDetail.vue?vue&type=style&index=0&id=3fe54f1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe54f1a",
  null
  
)

export default component.exports